import { IoClose } from "react-icons/io5";
import styled from "styled-components";

import { HeroInput, HeroInputField2, HeroInputIcon, HeroInputReset } from "../../../../modules/ui-kit";

export default function TokenInput(props) {
    const { label, onChange, value } = props;
    return (
        <Styled>
            <HeroInputField2>
                <HeroInputIcon />
                <HeroInput
                    autoFocus
                    onChange={ onChange }
                    placeholder="Search"
                    value={ value }
                />
                <HeroInputReset
                    onClick={ () => onChange("") }
                >
                    <IoClose />
                </HeroInputReset>
            </HeroInputField2>
            <span className="label">{ label }</span>
        </Styled>
    );
}

const Styled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-left: 6px;

    .label {
        cursor: default;
        font-family: var(--font-mono), monospace;
        font-size: .7rem;
        grid-column: 1 / 2;
        opacity: .6;
        padding: 0 2px;
        white-space: nowrap;
    }
`;
